import { useParams } from 'react-router';
import NewActivityTypeForm from './new';

export default function EditActivityType() {
  const { activityType = '' } = useParams();

  return <NewActivityTypeForm isEdit currentActivity={activityType} />;
}
